<!--
 * @Description: Description
 * @Autor: Chen
 * @Date: 2021-02-23 09:29:47
 * @LastEditors: snzo.chen
 * @LastEditTime: 2023-02-14 10:15:02
-->
<div class="cqesa-header">
  <div class="header-top" *ngIf="userHeader">
    <div class="header-user">
      <div class="header-user-name">{{userHeader}}</div>
      <a class="header-exit" (click)="exit()">退出登录</a>
    </div>
  </div>

</div>
<div class="layout">
  <div class="layout-top">
    <div class="league-header">
      <div class="header-top">
        <div class="header-info">全国学校体育联盟(机器人)</div>
        <div class="header-logo"><img [src]="'/assets/images/layout/logo.png'" alt=""></div>
        <div class="header-info">全国服务电话 95130211</div>
      </div>
      <div class="header-menu">
        <ul class="menu-top-box">
          <li class="menu-top-item" *ngFor="let item of menuConfig;index as i">
            <a class="menu-top-text" *ngIf="!item.disabled&&item.typeId&&item.isShow&&item.url"
              [href]="unionUrl + '/#' + item.url + '/' + item.typeId +'-'+ i">
              {{item.title}}
            </a>
            <a class="menu-top-text" *ngIf="!item.disabled&&!item.typeId&&item.isShow&&item.url"
              [href]="unionUrl + '/#' + item.url">
              {{item.title}}
            </a>
            <a class="menu-top-text" *ngIf="!item.disabled&&item.isShow&&item.outUrl" [href]="item.outUrl"
              target="_blank">
              {{item.title}}
            </a>
            <a class="menu-top-text" *ngIf="item.disabled&&item.isShow">
              {{item.title}}
            </a>
            <ul class="menu-sub-box" *ngIf="item.children&&!item.hideChildren&&item.isShow">
              <ng-container *ngFor="let subItem of item.children; index as j">
                <li class="menu-sub-item" *ngIf="subItem.isShow">
                  <a class="menu-sub-text" *ngIf="subItem.isShow && subItem.url"
                    [href]="unionUrl + '/#' + subItem.url + '/' + subItem.typeId +'-'+ i + '-' + j"
                    [innerHTML]="subItem.title"></a>
                  <a *ngIf="subItem.isShow && !subItem.url" [innerHTML]="subItem.title"></a>
                </li>
              </ng-container>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <div class="league-content">
      <router-outlet></router-outlet>
    </div>
  </div>
  <div class="layout-bottom">
    <div class="friend-link">
      <div class="friend-wrap">
        <div class="friend-box" #partnerList (mouseover)="stopMarquee()" (mouseout)="startMqrquee()">
          <div class="friend-items" #partnerItem01>
            <a class="friend-item" *ngFor="let item of friendOfData" [href]="item.urlAddress" target="_blank"><img
                [src]="unionUrl+item.photoAddress"></a>
          </div>
          <div class="friend-items" #partnerItem02>
            <a class="friend-item" *ngFor="let item of friendOfData" [href]="item.urlAddress" target="_blank"><img
                [src]="unionUrl+item.photoAddress"></a>
          </div>
        </div>
      </div>
    </div>
    <div class="league-footer">
      <div class="footer-content">
        <div class="copyright">
          <p>版权所有 神州通信集团素质教育推广委员会 <a href="https://beian.miit.gov.cn" target="_blank">京ICP备10003940号</a>
            京公网安备11011202002568号 神州通信北京电信技术研究院技术支持</p>
          <p>主办单位：中华人民共和国教育部</p>
        </div>
      </div>
    </div>
  </div>
</div>